import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import styled from 'styled-components';
import EditPen from 'utils/images/edit-pen.svg';

const Container = styled.div`
  padding: 0 !important;

  > button {
    height: 30px;
    width: 30px;
    padding: 3px !important;
    border: 1px solid #ddd;
    border: border-box;

    :hover {
      border-color: #000;
      background-color: #fff;
    }
  }
`;

const EditIcon = styled.img`
  width: 12px;
`;

function EditButton(props) {
  return (
    <Container className={props.className}>
      <IconButton onClick={e => props.onClick(e)}>
        <EditIcon src={EditPen} alt="Edit" />
      </IconButton>
    </Container>
  );
}

export default EditButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditButton/index.jsx